// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__25fVN","alertIcon":"ConfirmModal_alertIcon__ruDYv"};